import { generateClient } from "aws-amplify/api";
import { createCargoMovement, updateCargoMovement, deleteCargoMovement as removeCargoMovement } from "graphql/customs/mutations";
import { getCargoMovement as fetchCargoMovement, cargoMovementsByDate } from "graphql/queries";
import { showAlert } from "utils/Alert";
import { cleanUpData, getCounterTypeByCargoType, getDataFromResponse, getNotDeletedItems } from "utils/Api";
import { sequenceGenerator } from "utils/Form";
import { getPackages, savePackage } from "./PackagesApi";
import { getTypeCounterByName, increaseTypeCounter } from "./TypeCounterApi";

const API = generateClient();

export const saveCargoMovement = async (data, packagesList) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updateCargoMovement : createCargoMovement;
    let cleanData = cleanUpData(data);
    delete cleanData["boxes"];
    cleanData["type"] = "CargoMovement";

    let counter;
    if (operationName === "create") {
        const sequenceType = getCounterTypeByCargoType(data.tipo_transporte);
        counter = await getTypeCounterByName(sequenceType);
        const sequenceNumber = sequenceGenerator(sequenceType, counter, true);
        cleanData = {
            ...cleanData,
            secuencia: sequenceNumber
        };
    }

    const saveOperation = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData,
        }
    });
    const cargoMovementId = saveOperation.data.createCargoMovement ? saveOperation.data.createCargoMovement.id : data.id;

    return getPackages({
        cargoMovementBoxesId: { eq: cargoMovementId }
    }).then(async (oldPackages) => {
        const oldPackagesPromises = oldPackages.map((p) => {
            const packageData = {
                ...p,
                cargoMovementBoxesId: null
            }
            return savePackage(packageData);
        });

        const increasePromise = operationName === "create" ? increaseTypeCounter(counter) : true;
        return Promise.all([...oldPackagesPromises], increasePromise);
    }).then((r) => {
        const packagesPromises = Object.keys(packagesList).map((key) => {
            const boxData = packagesList[key];
            const packageData = {
                ...boxData,
                cargoMovementBoxesId: cargoMovementId
            }
            return savePackage(packageData);
        });
        return Promise.all([...packagesPromises]);
    }).then((r) => {
        if (operationName === "create") {
            showAlert("success", `El movimiento de carga se creo con la secuencia #${cleanData.secuencia}`);
        }
    });
};

export const getCargoMovements = async (filter = {}) => {
    const data = await API.graphql({
        query: cargoMovementsByDate,
        variables: {
            "filter": filter,
            "type": "CargoMovement",
            "sortDirection": "DESC"
        },
    })
    return getNotDeletedItems(data, "cargoMovementsByDate");
}

export const getCargoMovement = async (cargoId) => {
    let cargoObject = await API.graphql({
        query: fetchCargoMovement,
        variables: {
            id: cargoId
        }
    });
    return getDataFromResponse(cargoObject, "getCargoMovement");
}

export const deleteCargoMovement = async (cargoData) => {
    const deletedAsset = await API.graphql({
        query: removeCargoMovement,
        variables: {
            input: {
                "id": cargoData.id,
            }
        }
    });

    if (cargoData.boxes && cargoData.boxes.items) {
        const boxesPromises = cargoData.boxes.items.map((box) => {
            const packageData = {
                ...box,
                cargoMovementBoxesId: null
            }
            return savePackage(packageData);
        })
        await Promise.all(boxesPromises);
    }

    return getDataFromResponse(deletedAsset, "deleteCargoMovement");
}